import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SearchInput from '@/components/ui/SearchInput.vue';
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import DataTableHeader from '@/components/chunks/DataTableHeader.vue';
import { useUserStore } from '@/store/user';
import { User } from '@/types';
import { DEFAULT_PAGINATION_PAGE, PAGINATION_TABLES_NAMES, PROVIDE_KEYS, DATE_FORMAT} from '@/utils/constants';
import { getUserStatusText } from '@/utils/functions';
import { inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';
import { SortItem } from '@/types/SortItem';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTable',
  setup(__props) {

const { showSnackbar }: any = inject(PROVIDE_KEYS.SNACKBAR);
const { t } = useI18n();
let userStore = useUserStore();
const router = useRouter();
let deleteCandidate = {} as User;
const { handleUpdatePageSize, getTablePageSize, handleUpdateOrder, getTableOrder, getTablePage, handleUpdatePage } = useTablePaginationMixin();
const pageSize = ref(getTablePageSize(PAGINATION_TABLES_NAMES.USERS));
const currentPage = ref(DEFAULT_PAGINATION_PAGE);
const savedOrder: SortItem = getTableOrder(PAGINATION_TABLES_NAMES.USERS);
const startOrder = savedOrder && Object.keys(savedOrder).length > 0 ? savedOrder : {key:'createdAt', order:'desc'};
const currentOrder = ref([startOrder] as SortItem[]);

const userDeleteConfirm = ref();

const headers: any = [
  { title: 'TextField.FirstName', key: 'firstName' },
  { title: 'TextField.LastName', key: 'lastName' },
  { title: 'TextField.Email', key: 'email' },
  { title: 'TextField.Status', key: 'status' },
  { title: 'TextField.CreatedAt', key: 'createdAt' },
  { title: 'TextField.Actions', key: 'actions' }
];
let search = ref('');

userStore.fetchUsers().catch(() => showSnackbar('ResponseMessage.InternalError')).finally(()=>currentPage.value = getTablePage(PAGINATION_TABLES_NAMES.USERS));

function onUpdatePage(value: number) {
  currentPage.value = value;
  handleUpdatePage(PAGINATION_TABLES_NAMES.USERS, value);
}

function onUpdateItemsPerPage(value: number) {
  pageSize.value = value;
  handleUpdatePageSize(PAGINATION_TABLES_NAMES.USERS, value);
}

function onUpdateSortBy(options:SortItem[]){  
  const value = options[0];
  handleUpdateOrder(PAGINATION_TABLES_NAMES.USERS, value);  
}

function handleClickRow(rowItem: any, data: any) {
  const row = data.item;
  if (!row.inProcess) {
    router.push({ name: 'UpdateUser', params: { userId: row.id } });
  }
}

function deleteRow(data: User) {
  userDeleteConfirm.value.open();
  deleteCandidate = data;
}

function clickOkConfirm() {
  userStore
    .deleteUser(deleteCandidate.id!)
    .then(() => {
      showSnackbar('ResponseMessage.User.Delete.Success');
    })
    .catch(() => {
      showSnackbar('ResponseMessage.User.Delete.Error');
    });
}
function onCloseConfirm() {
  deleteCandidate = {} as User;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SearchInput, {
      modelValue: _unref(search),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event)),
      class: "mb-2"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_v_data_table, {
      "sort-by": currentOrder.value,
      "onUpdate:sortBy": [
        _cache[1] || (_cache[1] = ($event: any) => ((currentOrder).value = $event)),
        onUpdateSortBy
      ],
      headers: headers,
      items: _unref(userStore).getUsers,
      search: _unref(search),
      "items-per-page": pageSize.value,
      page: currentPage.value,
      "onClick:row": handleClickRow,
      "onUpdate:itemsPerPage": onUpdateItemsPerPage,
      "onUpdate:page": onUpdatePage
    }, {
      headers: _withCtx(({ columns, isSorted, getSortIcon, toggleSort }) => [
        _createVNode(DataTableHeader, {
          columns: columns,
          "is-sorted": isSorted,
          "get-sort-icon": getSortIcon,
          "toggle-sort": toggleSort
        }, null, 8, ["columns", "is-sorted", "get-sort-icon", "toggle-sort"])
      ]),
      [`item.status`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_unref(t)(_unref(getUserStatusText)(item.status))), 1)
      ]),
      [`item.createdAt`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(item.createdAt).format(_unref(DATE_FORMAT))), 1)
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          loading: (item as User).inProcess,
          variant: "text",
          icon: "mdi-delete-empty-outline",
          color: "error",
          class: "ml-4",
          onClick: _withModifiers(($event: any) => (deleteRow(item as User)), ["stop"])
        }, null, 8, ["loading", "onClick"])
      ]),
      _: 2
    }, 1032, ["sort-by", "items", "search", "items-per-page", "page"]),
    _createVNode(ConfirmDialog, {
      ref_key: "userDeleteConfirm",
      ref: userDeleteConfirm,
      onClickOk: clickOkConfirm,
      onClose: onCloseConfirm
    }, null, 512)
  ], 64))
}
}

})